"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverEditor = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var __1 = require("../");
var translation_1 = require("../../utils/translation");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('CoverEditor'), (0, recompose_1.withState)('imageStatus', 'setStatus', 'NOTFOUND'), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (this.props.image !== nextProps.image &&
            nextProps.image !== undefined) {
            this.props.setStatus('LOADING');
        }
        else if (nextProps.imageStatus !== 'NOTFOUND' &&
            nextProps.image === undefined) {
            this.props.setStatus('NOTFOUND');
        }
    }
}), (0, recompose_1.defaultProps)({
    imageWidth: 400,
    imageHeight: 300
}));
exports.CoverEditor = enhance(function (props) { return (React.createElement("div", { className: 'sok-cover-editor ' + props.className || '' },
    React.createElement("div", { className: "sok-cover-editor-image ".concat(props.imageStatus === 'LOADED' ? 'has-image' : '') },
        !props.isUploading && props.image ? (React.createElement(__1.SmoothImage, { src: props.image, onStatus: function (status) { return props.setStatus(status); } })) : (props.imageStatus !== 'LOADING' &&
            (!props.isUploading || !props.image) &&
            (props.disabled ? (React.createElement("div", null, "No image.")) : (React.createElement("div", { className: 'sok-cover-editor-image-no-image' },
                React.createElement("div", { className: "icon" },
                    React.createElement(__1.Icon, { className: "fa-cloud-upload" })),
                React.createElement("div", null, (0, translation_1.getLocalization)('components/CoverEditor/dragDropImageUpload')))))),
        (props.isUploading || props.imageStatus === 'LOADING') && (React.createElement("div", { className: 'sok-cover-editor-image-loading' },
            React.createElement(__1.LoadingSpinner, null)))),
    !props.disabled &&
        !props.isUploading && (React.createElement("div", { className: "sok-cover-editor-buttons" },
        React.createElement(__1.FileButton, { icon: React.createElement(__1.Icon, { className: "fa-cloud-upload" }), color: "green", disabled: props.isUploading, accept: "image/x-png,image/gif,image/jpeg", onFileChange: function (e) {
                if (e.target.files) {
                    props.onUpload(e.target.files[0]);
                }
            } }, (0, translation_1.getLocalization)('components/CoverEditor/upload')),
        React.createElement(__1.Button, { icon: React.createElement(__1.Icon, { className: "fa-times-circle" }), color: "red", onClick: function () {
                props.onRemove();
                props.setStatus('NOTFOUND');
            }, disabled: props.isUploading || props.imageStatus === 'NOTFOUND' }, (0, translation_1.getLocalization)('components/CoverEditor/remove')))))); });
//# sourceMappingURL=index.js.map